import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import RegistrationForm from './components/auth/RegistrationForm';
import PrivateRoute from './components/auth/PrivateRoute';
import LandingPage from './components/landing/LandingPage';
import AgentsPage from './components/controlplane/AgentsPage';
import DisputesPage from './components/controlplane/DisputesPage';
import PoliciesPage from './components/controlplane/PoliciesPage';
import ProvidersPage from './components/controlplane/ProvidersPage';
import RequestDetailPage from './components/controlplane/RequestDetailPage';
import SettlementPage from './components/controlplane/SettlementPage';
import TemplatesPage from './components/controlplane/TemplatesPage';
import RequestsPage from './components/requests/RequestsPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthCallback from './components/auth/AuthCallback';
import {
  APP_AGENTS_PATH,
  APP_AUTH_CALLBACK_PATH,
  APP_DASHBOARD_PATH,
  APP_DISPUTES_PATH,
  APP_POLICIES_PATH,
  APP_PROVIDERS_PATH,
  APP_REQUEST_DETAIL_PATH,
  APP_REGISTER_PATH,
  APP_REQUESTS_PATH,
  APP_SETTLEMENT_PATH,
  APP_TEMPLATES_PATH,
} from './routes';

const LegacyAuthCallbackRedirect = () => {
  const location = useLocation();

  return <Redirect to={`${APP_AUTH_CALLBACK_PATH}${location.search || ''}`} />;
};

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route exact path={APP_REGISTER_PATH} component={RegistrationForm} />
        <PrivateRoute exact path={APP_REQUESTS_PATH} component={RequestsPage} />
        <PrivateRoute exact path={APP_REQUEST_DETAIL_PATH} component={RequestDetailPage} />
        <PrivateRoute exact path={APP_TEMPLATES_PATH} component={TemplatesPage} />
        <PrivateRoute exact path={APP_AGENTS_PATH} component={AgentsPage} />
        <PrivateRoute exact path={APP_PROVIDERS_PATH} component={ProvidersPage} />
        <PrivateRoute exact path={APP_SETTLEMENT_PATH} component={SettlementPage} />
        <PrivateRoute exact path={APP_DISPUTES_PATH} component={DisputesPage} />
        <PrivateRoute exact path={APP_POLICIES_PATH} component={PoliciesPage} />
        <Route exact path={APP_AUTH_CALLBACK_PATH} component={AuthCallback} />
        <Redirect exact from="/register" to={APP_REGISTER_PATH} />
        <Redirect exact from="/dashboard" to={APP_REQUESTS_PATH} />
        <Redirect exact from={APP_DASHBOARD_PATH} to={APP_REQUESTS_PATH} />
        <Route exact path="/auth/callback" component={LegacyAuthCallbackRedirect} />
        <Redirect exact from="/app" to={APP_REQUESTS_PATH} />
        <Redirect to="/" />
      </Switch>
      <ToastContainer />
    </Router>
  );
};

export default App;
